/** Curated host public-page themes — cycle order is fixed. */

export const DEFAULT_HOST_THEME = "warm-editorial";

export const HOST_THEME_IDS = [
  "warm-editorial",
  "playful-salsa",
  "midnight-groove",
  "neon-fiesta",
  "tropical-sun",
];

const LEGACY_THEMES = new Set(["sticker", "readable", "quiet"]);

export const HOST_THEMES = {
  "warm-editorial": {
    id: "warm-editorial",
    name: "Warm Editorial",
    description: "Quiet warm light — charcoal CTAs (current default).",
    /* muted is AA body contrast (≥4.5:1) on that theme's canvas */
    preview: { canvas: "#FBF9F5", ink: "#121212", muted: "#4A4A4A", cta: "#121212", ctaFg: "#FFFFFF" },
    mark: ["#2a2622", "#121212", "#3a3430"],
    dark: false,
  },
  "playful-salsa": {
    id: "playful-salsa",
    name: "Playful Salsa",
    description: "Warm cream floor with salsa-chili CTAs and mango status accents.",
    preview: { canvas: "#FAF6F0", ink: "#1A0C0E", muted: "#5C524C", cta: "#D90429", ctaFg: "#FFFFFF" },
    mark: ["#D90429", "#B8001F", "#FFB703"],
    dark: false,
  },
  "midnight-groove": {
    id: "midnight-groove",
    name: "Midnight Groove",
    description: "Cool ebony lounge — ember CTAs, cream type, amber accents.",
    preview: { canvas: "#100E11", ink: "#F4EFEA", muted: "#C4B8B5", cta: "#E63946", ctaFg: "#100E11" },
    mark: ["#E63946", "#100E11", "#FFB703"],
    dark: true,
  },
  "neon-fiesta": {
    id: "neon-fiesta",
    name: "Neon Fiesta",
    description: "Night social energy — hot pink CTAs on deep slate.",
    preview: { canvas: "#0F1419", ink: "#F5F7FA", muted: "#B8C0CC", cta: "#FF2D6A", ctaFg: "#0A0E12" },
    mark: ["#FF2D6A", "#1A222C", "#00E5C3"],
    dark: true,
  },
  "tropical-sun": {
    id: "tropical-sun",
    name: "Tropical Sun",
    description: "Sunny canvas with deep teal actions.",
    preview: { canvas: "#FFF9E8", ink: "#1A2E1A", muted: "#3D5A3D", cta: "#0D7377", ctaFg: "#FFFFFF" },
    mark: ["#0D7377", "#1B4332", "#E8A317"],
    dark: false,
  },
};

export function normalizeHostTheme(raw) {
  const s = String(raw || "").trim();
  if (HOST_THEME_IDS.includes(s)) return s;
  if (!s || LEGACY_THEMES.has(s)) return DEFAULT_HOST_THEME;
  return DEFAULT_HOST_THEME;
}

export function nextHostTheme(id) {
  const current = normalizeHostTheme(id);
  const idx = HOST_THEME_IDS.indexOf(current);
  return HOST_THEME_IDS[(idx + 1) % HOST_THEME_IDS.length];
}

export function hostThemeMeta(id) {
  return HOST_THEMES[normalizeHostTheme(id)];
}

export function hostThemeMarkStops(id) {
  return hostThemeMeta(id).mark;
}

export const HOST_THEME_PREVIEW_KEY = "rsvp.hostThemePreview";

export function readPreviewHostTheme() {
  try {
    return normalizeHostTheme(sessionStorage.getItem(HOST_THEME_PREVIEW_KEY));
  } catch {
    return DEFAULT_HOST_THEME;
  }
}

export function writePreviewHostTheme(id) {
  const next = normalizeHostTheme(id);
  try {
    sessionStorage.setItem(HOST_THEME_PREVIEW_KEY, next);
  } catch {
    /* ignore quota / private mode */
  }
  return next;
}
